import React from "react";
// import "@babel/polyfill";
import { connect } from "react-redux";
import TopNav from "components/layout/TopNav";
import Main from "components/layout/Main";
import Footer from "components/layout/Footer";
import { getUg } from "actions/ugActions";
import "assets/stylesheets/App.scss";

class App extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(getUg());
  };

  render() {
    const version = process.env.REACT_APP_VERSION_INFO;
    return (
      <div data-app-version={version}>
        <h1 className="sr-only" tabIndex={0}>
          Course Compass
        </h1>
        <TopNav />
        <Main />
        <Footer />
      </div>
    );
  }
}

export default connect()(App);
